<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="main-content">
  <div class="page-content">
    <div class="container-fluid">
      <!-- start page title -->
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-flex align-items-center justify-content-between">
            <h4 class="mb-0 font-size-18">
              <i class="bx bx-home-circle"></i>  {{'dashboard.welcome' | translate}}
              <app-fildariane></app-fildariane>
            </h4>
            <div class="page-title-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item"><a href="javascript: void(0);">{{'navigation.home' | translate}}</a></li>
                <li class="breadcrumb-item active">{{'pages.manageSubCertifications' | translate}}
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- end row -->

      <div class="row">

        <div class="col-lg-12">
          <div class="alert alert-success text-center" role="alert" *ngIf="addingSuccess">
            {{'messages.actionCompletedWith' | translate}} <a href="#" class="alert-link">{{'messages.success' | translate}}</a>.
            <button type="button" class="close" data-dismiss="alert" [attr.aria-label]="'common.close' | translate">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <a href="javascript:window.history.back();" class="mb-2 btn btn-primary waves-effect waves-light btn-sm mb-3"><i class="mdi mdi-chevron-left ml-1"></i> {{'common.back' | translate}} </a>

          <div class="card">
            <div class="card-body">

              <h4 class="card-title">{{'pages.editSubCertification' | translate}}</h4>
              <div class="form-group row">
                <label class="col-md-2 col-form-label">{{'messages.selectCertification' | translate}}</label>
                <div class="col-md-10">
                  <select class="custom-select" [(ngModel)]="single_sub_certificats.certificat_id">
                    <option *ngFor="let certificat of certificats; let i = index" [value]="certificat.id">{{certificat.name}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-2 col-form-label">{{'fields.label' | translate}}</label>
                <div class="col-md-10">
                  <input class="form-control" type="text" [(ngModel)]="single_sub_certificats.name">
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-2 col-form-label">{{'fields.description' | translate}}</label>
                <div class="col-md-10">
                  <textarea required="" class="form-control" rows="5" [(ngModel)]="single_sub_certificats.description"></textarea>
                </div>
              </div>
              <ng-container *ngIf="entityType == 'EKAMPUS'">
              <div class="form-group row">
                <label class="col-md-2 col-form-label">{{'fields.sites' | translate}}</label>
                <div class="col-md-10">
                  <ng-container *ngFor="let site of sites; let c = check">
                    <div class="form-check form-check-inline col-md-2">
                      <ng-container *ngIf="check_value(site.id) == true">
                        <input class="form-check-input" type="checkbox" checked (change)=" check(site.id, $event.target.checked);" #c  id="{{site.id}}" value="{{site.id}}">
                        <label class="form-check-label" [style.color]="c.checked || check_value(site.id) == true ? '#0000FF':'' "  for="{{site.id}}">{{site.name}}</label>
                      </ng-container>
                      <ng-container *ngIf="check_value(site.id) == false">
                        <input class="form-check-input" type="checkbox" (change)=" check(site.id, $event.target.checked);" #c  id="{{site.id}}" value="{{site.id}}">
                        <label class="form-check-label" [style.color]="c.checked ? '#0000FF':'' "  for="{{site.id}}">{{site.name}}</label>
                      </ng-container>
                    </div>
                  </ng-container>
                </div>
              </div>
              </ng-container>

              <div class="form-group row">
                <label class="col-md-2 col-form-label">{{'fields.validity' | translate}}</label>
                <div class="form-group">
                  <select class="form-control" [(ngModel)]="readioSelected" (change)="changeValidite($event)">
                    <option [value]="1">{{'fields.byDate' | translate}}</option>
                    <option [value]="2">{{'fields.byDurationMonths' | translate}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group row" *ngIf="readioSelected == 1">
                <label class="col-md-2 col-form-label">{{'fields.date' | translate}}</label>
                <div class="col-md-3">
                  <input class="form-control" type="date" [(ngModel)]="single_sub_certificats.date" value="{{single_sub_certificats.date}}">
                  <input class="form-control" type="hidden" [(ngModel)]="single_sub_certificats.id">
                </div>
              </div>
              <div class="form-group row" *ngIf="readioSelected == 2">
                <label class="col-md-2 col-form-label">{{'fields.duration' | translate}}</label>
                <div class="col-md-3">
                  <input class="form-control" type="text" [(ngModel)]="single_sub_certificats.delay" value="{{single_sub_certificats.delay}}">
                  <input class="form-control" type="hidden" [(ngModel)]="single_sub_certificats.id">
                </div>
              </div>


              <div class="form-group text-center">
                <button type="button" class="btn btn-primary waves-effect waves-light" (click)="edit_sous_certificat()">
                  {{'common.validate' | translate}}
                </button>
              </div>
            </div>
          </div>
          <!-- end row -->
          <!-- end row -->
        </div>
        <!-- container-fluid -->
      </div>
      </div>
      </div>
      </div>
      <!-- End Page-content -->
      <app-footer></app-footer>
